// CS2 defuse HUD wash: red -> yellow (50%) -> green, one colour at a time.
export function washColor(p: number) {
  const lerp = (a: number[], b: number[], t: number) =>
    a.map((v, i) => Math.round(v + (b[i] - v) * t))
  const c =
    p < 0.5
      ? lerp([255, 0, 0], [255, 255, 0], p * 2)
      : lerp([255, 255, 0], [0, 128, 0], (p - 0.5) * 2)
  return `rgb(${c.join(',')})`
}
